import * as React from "react"
import { Box, Typography } from "@mui/material"

import { ManagementPricingConfigPendingChip } from "../../@components"


/** The SKU the RRSP applies to. Shows the customer's alias when it has one (the query resolves it). */
export default function skuColumn() {
    return {
        name: 'skuName', label: 'SKU',
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRenderLite: (value, row) => <Box
                display="flex" justifyContent="center" alignItems="center"
            >
                {value ?? '—'}
                <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                    #{row.skuID}
                </Typography>
                <ManagementPricingConfigPendingChip pending={row.pending} />
            </Box>
        }
    }
}
